const createMessageSignerApi = ({ messageSigner }) => {
    return {
        messageSigner: {
            signMessage: messageSigner.signMessage,
        },
    };
};
const messageSignerApiDefinition = {
    id: 'messageSignerApi',
    type: 'api',
    factory: createMessageSignerApi,
    dependencies: ['messageSigner'],
};
export default messageSignerApiDefinition;
